(() => {
  'use strict';

  if (window.__SQ_VIEW_TRANSITIONS_DISABLED_FOR_SPEED__) return;
  window.__SQ_VIEW_TRANSITIONS_DISABLED_FOR_SPEED__ = true;

  const releaseRenderBlocker = () => {
    document.getElementById('view-transition-render-blocker')?.remove();
  };

  releaseRenderBlocker();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseRenderBlocker, { once: true });
  }

  window.addEventListener('pageshow', releaseRenderBlocker, { passive: true });
})();
